<template>
    <div class="tile_container">
        <DialogTile title="Add tile">
            <Notification :type="n_type" :message="n_message" />
            <form @submit="submitAddTile" ref="add_tile">
                <TileSelection @selectedTile="selectTile" />
                <input type="text" placeholder="Title of tile" id="title" v-model="tile_title" >
                <div style="height: 50px;"></div>
                <div id="optional_settings" style="text-align:left;" v-if="tile.settings">
                    <h4>Settings</h4>
                    <SettingComponent
                        v-for="setting in tile.settings"
                        :key="setting.name"
                        :tile_path="tile.path"
                        :type="setting.type"
                        :name="setting.name"
                        :label="setting.label"
                        :placeholder="setting.placeholder"
                        :required="setting.required"
                        :oauth_settings="{
                            type: setting.oauth_type,
                            code_url: setting.oauth_auth_code_url,
                            token_url: setting.oauth_auth_token_url,
                            additional_parameters: setting.oauth_additional_parameters,
                            scope: setting.scope,
                            scope_delimiter: setting.scope_delimiter,
                            client_id: setting.client_id,
                            client_secret: setting.client_secret
                            }"
                    />
                </div>
                <button type="submit" style="width:50%;">
                    <i class="fal fa-plus" style="font-size:23px;"></i>
                    <span style="margin-left: 30px;">Add</span>
                </button>
            </form>
        </DialogTile>
    </div>
</template>

<script>
import { storage, auth } from "../schmucklicloud";

export default {
    data() {
        return {
            selection_options: [],
            n_message: "",
            n_type: "",

            tile: "",
            tile_title: "",
        }
    },
    mounted() {
        var session_token = window.localStorage.getItem("session_token");
        auth.checkSession(session_token).then(function(response){
            if (!response.isOK) {
                this.$router.replace("/login");
            }
        }.bind(this));
    },
    methods: {
        selectTile(tile){
            this.tile = tile;
        },
        submitAddTile(e) {
            e.preventDefault();

            var settings = {};

            //Fetch the settings
            if (this.tile.settings !== undefined && this.tile.settings.length > 0) {
                this.tile.settings.forEach(function (setting) {
                    var value = this.$refs.add_tile["setting_" + setting.name].value;
                    settings[setting.name] = value;
                }.bind(this));
            }

            storage.insert("tiles", {
                path: this.tile.path,
                title: this.tile_title,
                order: 99999,
                icon: this.tile.icon,
                settings: JSON.stringify(settings)
            }).then(function (response){
                if (response.isOK) {
                    this.n_message = "The tile has been saved";
                    this.n_type = "success";
                    this.$router.replace("/");
                } else {
                    this.n_type = "error";
                    this.n_message = response.message;
                }
            }.bind(this));
        }
    },
    watch: {
        tile(new_value) {
            this.tile_title = new_value.name;
        }
    }
}
</script>